import { render, staticRenderFns } from "./VerticalLinks.vue?vue&type=template&id=3a1bb608&scoped=true&"
import script from "./VerticalLinks.vue?vue&type=script&lang=js&"
export * from "./VerticalLinks.vue?vue&type=script&lang=js&"
import style0 from "./VerticalLinks.vue?vue&type=style&index=0&id=3a1bb608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1bb608",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemTitle})
